import ApiService from '../apiservice'

export default class HistoricoPessoaService extends ApiService {
  constructor() {
    super('/historicoPessoa');
  }

  consultarHistorico(dataInicial,dataFinal) {
    return this.get(`/por-datas?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  cadastrarHistorico(historico) {
    return this.post('/',historico);
  }

  excluirHistorico(codigo) {
    return this.delete(`/${codigo}`);
  }

  listarPorPessoa(pessoa) {
    return this.get(`/por-pessoa/${pessoa}`);
  }
}